__turbopack_context__.v({
  "additionalContent": "buy-now-pay-later-options-module-scss-module__Q_BByW__additionalContent",
  "additionalContentContainer": "buy-now-pay-later-options-module-scss-module__Q_BByW__additionalContentContainer",
  "affirmCtaText": "buy-now-pay-later-options-module-scss-module__Q_BByW__affirmCtaText",
  "alternativeLabel": "buy-now-pay-later-options-module-scss-module__Q_BByW__alternativeLabel",
  "buttonLink": "buy-now-pay-later-options-module-scss-module__Q_BByW__buttonLink",
  "heading": "buy-now-pay-later-options-module-scss-module__Q_BByW__heading",
  "icon-american-express": "buy-now-pay-later-options-module-scss-module__Q_BByW__icon-american-express",
  "icon-arrow": "buy-now-pay-later-options-module-scss-module__Q_BByW__icon-arrow",
  "icon-chat": "buy-now-pay-later-options-module-scss-module__Q_BByW__icon-chat",
  "icon-cross": "buy-now-pay-later-options-module-scss-module__Q_BByW__icon-cross",
  "icon-discover": "buy-now-pay-later-options-module-scss-module__Q_BByW__icon-discover",
  "icon-mastercard": "buy-now-pay-later-options-module-scss-module__Q_BByW__icon-mastercard",
  "icon-visa": "buy-now-pay-later-options-module-scss-module__Q_BByW__icon-visa",
  "location": "buy-now-pay-later-options-module-scss-module__Q_BByW__location",
  "monthlyCostAmount": "buy-now-pay-later-options-module-scss-module__Q_BByW__monthlyCostAmount",
  "offerContainer": "buy-now-pay-later-options-module-scss-module__Q_BByW__offerContainer",
  "offerHeading": "buy-now-pay-later-options-module-scss-module__Q_BByW__offerHeading",
  "offerSection": "buy-now-pay-later-options-module-scss-module__Q_BByW__offerSection",
  "offerText": "buy-now-pay-later-options-module-scss-module__Q_BByW__offerText",
  "onlyProgresive": "buy-now-pay-later-options-module-scss-module__Q_BByW__onlyProgresive",
  "partition": "buy-now-pay-later-options-module-scss-module__Q_BByW__partition",
  "phone": "buy-now-pay-later-options-module-scss-module__Q_BByW__phone",
  "progressive": "buy-now-pay-later-options-module-scss-module__Q_BByW__progressive",
  "progressiveCtaText": "buy-now-pay-later-options-module-scss-module__Q_BByW__progressiveCtaText",
  "rightSection": "buy-now-pay-later-options-module-scss-module__Q_BByW__rightSection",
  "section": "buy-now-pay-later-options-module-scss-module__Q_BByW__section",
  "trade-mark": "buy-now-pay-later-options-module-scss-module__Q_BByW__trade-mark",
});
